import { RoleEnum } from '../enums/roleEnum';

/**
 * Admin permission claims the invoice and Odoo endpoints require (API_CHANGES_ADMIN_ODOO.md §0).
 * Every GET under /api/admin/invoices and /api/admin/odoo takes `View`; every POST (mark paid,
 * credit note, resend email, resyncs) takes `Manage`.
 *
 * `admin.superadmin` and a full Admin pass both; AuthService.hasAdminPermission() handles that.
 */
export const InvoicePermissions = {
  View: 'invoices.view',
  Manage: 'invoices.manage',
} as const;

// The routes and the sidenav items all spread INVOICES_ACCESS, so what a SubAdmin can see and what
// they can open cannot drift apart.
export const INVOICES_ACCESS = {
  roles: [RoleEnum.Admin, RoleEnum.SubAdmin],
  permission: InvoicePermissions.View,
};
